import {Link} from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';

import LinkBox from "../LinkBox"

//import "./Mosaics.css";
import "../Common.css"

function Games()
{
    return (
        <div>
            <Container>
                <Row>
                    <Col xs={{ span: 12 }} className="topBuffer spacer-sm">
                        <p>Games</p>
                    </Col>

                    <Col className="column" md={{ span: 5, offset: 1 }} sm={{ span: 10, offset: 1}} >
                        <p>Lego Chess</p>
                        <a href="/legoChess/index.html">
                            <img className="img-responsive LinkBox" src="assets/Games/LegoChess.png" width={"100%"} alt="Lego Chess"/>
                        </a>
                    </Col>

                    <LinkBox name="Bolbi" href="Bolbi" image="assets/Games/Bolbi.png" offset={0} />
                    <LinkBox name="Tic Tac Toe" href="TicTacToe" image="assets/Games/TicTacToe.png" offset={1} />
                </Row>
            </Container>
            <Link to="/Home" className="logo"></Link>
        </div>
      )
}

export default Games;